import { render, staticRenderFns } from "./saveOrShareMarker.vue?vue&type=template&id=044885ac&scoped=true"
import script from "./saveOrShareMarker.vue?vue&type=script&lang=js"
export * from "./saveOrShareMarker.vue?vue&type=script&lang=js"
import style0 from "./saveOrShareMarker.vue?vue&type=style&index=0&id=044885ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044885ac",
  null
  
)

export default component.exports